import type { AreaCatalog } from '../area';
import type { viewControls as en } from '../en/viewControls';

export const viewControls = {
  'viewControls.arrange': 'Anordnen',
  'viewControls.choice.withCurrent': '{label} ({current})',
  'viewControls.display.label': 'Anzeige',
  'viewControls.display.labelClosedShown': 'Anzeige (Abgeschlossene sichtbar)',
  'viewControls.display.listsExpanded': 'Listen aufgeklappt',
  'viewControls.display.showClosed': 'Abgeschlossene anzeigen',
  'viewControls.display.hideClosed': 'Abgeschlossene ausblenden',
  'viewControls.display.showClosedCount': {
    one: '{count} abgeschlossene anzeigen',
    other: '{count} abgeschlossene anzeigen',
  },
  'viewControls.star.pin': 'An die Seitenleiste anheften',
  'viewControls.star.unpin': 'Von der Seitenleiste lösen',
  'viewControls.root.set': 'Ausgangsaufgabe festlegen…',
  'viewControls.root.open': '{title} öffnen',
  'viewControls.root.change': 'Ausgangsaufgabe ändern…',
  'viewControls.root.clear': 'Ausgangsaufgabe entfernen',
  'viewControls.root.chip': 'Ausgangsaufgabe',
  'viewControls.root.label': 'Ausgangsaufgabe',
  'viewControls.root.subtitleBoard':
    'Das Board zeigt die Unteraufgaben dieser Aufgabe, in jeder Tiefe.',
  'viewControls.root.search': 'Ausgangsaufgabe suchen',
  'viewControls.share.saveAsView': 'Als Board speichern…',
  'viewControls.share.shareWork': 'Die Aufgaben teilen…',
  'viewControls.share.audience': 'Personenkreis…',
  'viewControls.share.audienceFor': 'Personenkreis von {name}',
  'viewControls.share.onlyYou': 'Nur du',
  'viewControls.share.actionsFor': 'Aktionen für {name}',
  'viewControls.share.copied': 'Kopiert',
  'viewControls.share.boardOptions': 'Board-Optionen',
  'viewControls.share.viewOptions': 'Ansichtsoptionen',
  'viewControls.share.share': 'Teilen',
  'viewControls.card.rename': 'Umbenennen…',
  'viewControls.card.archive': 'Archivieren',
  'viewControls.card.archiveReach': 'Für alle',
  'viewControls.card.archiveTitleBoard':
    'Legt das Board für alle weg, die es haben. Es lässt sich wiederherstellen.',
  'viewControls.card.archiveTitleView':
    'Legt die Ansicht für alle weg, die sie haben. Sie lässt sich wiederherstellen.',
  'viewControls.card.restore': 'Wiederherstellen',
  'viewControls.card.leave': 'Verlassen',
  'viewControls.card.leaveReach': 'Nur du',
  'viewControls.card.leaveTitleBoard': 'Nimmt dich vom Board. Für alle anderen ändert sich nichts.',
  'viewControls.card.leaveTitleView':
    'Nimmt dich von der Ansicht. Für alle anderen ändert sich nichts.',
  'viewControls.rename.titleBoard': 'Board umbenennen',
  'viewControls.rename.titleView': 'Ansicht umbenennen',
  'viewControls.rename.name': 'Name',
  'viewControls.rename.save': 'Speichern',
  'viewControls.dialog.cancel': 'Abbrechen',
} as const satisfies AreaCatalog<typeof en>;
